import axios from "axios";



axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
// console.log(process.env.REACT_APP_API_BASE_URL);

  // axios.defaults.baseURL = "http://13.203.55.129:9500/v1";